
/**
 *  Промежуток времени ( между down и up событиями мыши в мс )
 *  при превышении которого клик будет игнорироваться
 *  необходимо для реализации выделения текста в таблицах, без перехода в карточку
 */
export const MOUSE_CLICK_TIMESTAMP = 150;

